module.exports = __webpack_public_path__ + "static/media/paw_tiger_large.5e0a573b.svg";